// Modules
import { CascadingDropdownModule } from 'NewAngular/features/components/dropdowns/cascading-dropdown/cascading-dropdown.module';
import { CommonModule } from '@angular/common';
import { ConfigModule } from 'NewAngular/config/config.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import { PaginationControlsModule } from 'NewAngular/features/components/pagination/pagination-controls/pagination-controls.module';
import { HoldingsDatePickerInlineModule } from 'SecuritiesApp/ts/features/holdings-date-picker-inline/holdings-date-picker-inline.module';
import * as i0 from "@angular/core";
export class HoldingsComparisonTableModule {
}
HoldingsComparisonTableModule.ɵfac = function HoldingsComparisonTableModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsComparisonTableModule)(); };
HoldingsComparisonTableModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HoldingsComparisonTableModule });
HoldingsComparisonTableModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CascadingDropdownModule,
        CommonModule,
        ConfigModule,
        DisabledModule,
        FeatureNeededModule,
        IconModule,
        LoadingSymbolModule,
        ModalBaseModule,
        ModuleUpsellModule,
        PaginationControlsModule,
        HoldingsDatePickerInlineModule] });
